<template>
  <div class="profile-info-block">
    <h2 class="rg-title">学歴</h2>
    <div class="table-responsive">
      <table class="table">
        <tbody>
        <tr>
          <th>最終学歴</th>
          <td>{{academic.last.title}}</td>
        </tr>
        <tr>
          <th>卒業学校名</th>
          <td>{{academic.instituteName}}</td>
        </tr>
        <tr>
          <th>卒業学部名<br>(大学卒業以上)</th>
          <td>{{academic.department}}</td>
        </tr>
        <tr>
          <th>卒業年</th>
          <td>{{academic.graduateYear}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div><!-- ends profile-info-block -->
</template>

<script>
export default {
  name: 'DAcademicInfo',
  props: {
    academic: {
      required: true,
    },
  },
  mounted() {
    this.$emit('academicLoaded');
  },
};
</script>
